import { useNode } from "@craftjs/core";
import React, { useRef, useEffect, useContext } from "react";
import { LottieSettings } from "./settings";
import GrigoraCSSRenderer from "./../css-render";
import icon from "./icon";
import { useScript } from "../../hooks";
import classnames from "classnames";
import { getDynamicCSS, getSupportProps } from "../../block-supports";

export const Lottie = (props) => {
  const {
    id,
    connectors: { connect, drag },
  } = useNode((state) => ({
    id: state.id,
    selected: state.events.selected,
    dragged: state.events.dragged,
  }));

  const {
    fileSource,
    lottieAnimationUrl,
    ariaLabel,
    autoplay = true,
    playOnHover,
    playbackSpeed,
    loopPlayback = true,
    limitLoops,
  } = props;

  var blockProps = getSupportProps({
    id,
    ...props,
  });

  const wrapperClass = classnames(
    {
      "g-lottie": true,
      [`lottie-${id}`]: id,
    },
    blockProps.className,
  );

  const lottieRef = useRef(null);

  const { lottie } = useScript(
    "https://cdnjs.cloudflare.com/ajax/libs/bodymovin/5.11.0/lottie.min.js",
    "lottie",
  );

  useEffect(() => {
    if (lottieAnimationUrl && lottie && lottie.loadAnimation) {
      if (
        lottie &&
        lottie.destroy &&
        lottie
          .getRegisteredAnimations()
          .some((item) => item.name === `lottie-${id}`)
      ) {
        lottie.destroy(`lottie-${id}`);
      }
      lottie?.loadAnimation({
        name: `lottie-${id}`,
        container: lottieRef.current,
        renderer: "svg",
        loop:
          limitLoops !== undefined || limitLoops === 0
            ? limitLoops
            : loopPlayback,
        autoplay: autoplay,
        // animationData: test, // switch to local files to load local files
        path: lottieAnimationUrl, // switch to path property to load url animations
      });
      if (playbackSpeed !== undefined) lottie?.setSpeed(playbackSpeed);
    }
  }, [
    lottie,
    lottieAnimationUrl,
    autoplay,
    playOnHover,
    playbackSpeed,
    loopPlayback,
    limitLoops,
  ]);
  // https://assets9.lottiefiles.com/packages/lf20_17p4evft.json
  return (
    <div
      {...blockProps}
      ref={(ref) => {
        connect(drag(ref));
        lottieRef.current = ref;
      }}
      className={wrapperClass}
      data-grigora-block="true"
      data-grigora-block-id={id}
      aria-label={ariaLabel}
    >
      <style>{`${getDynamicCSS(id, props)}`}</style>
      <style>{`${GrigoraCSSRenderer.blockCSS__Lottie(id, props)}`}</style>
      {!lottieAnimationUrl && (
        <div className="lottie-container">Add Lottie Animation</div>
      )}
    </div>
  );
};

// To Avoid Mangling in Production
Lottie.displayName = "Lottie";

Lottie.craft = {
  name: "Lottie",
  props: {},
  related: {
    settings: LottieSettings,
    hideFromToolbox: true,
    icon: icon,
    supports: [
      "grigora/entrance-animations",
      "grigora/css-transform-animations",
      "grigora/mouse-movement",
      "grigora/visibility",
      "grigora/position",
      "grigora/sticky",
      "grigora/filter",
      "grigora/custom-class",
      "grigora/custom-id",
    ],
    category: "miscellaneous",
    isHiddenInPostEditor: true,
  },
  custom: {
    name: "Lottie Animation",
    slug: "grigora/lottie",
  },
};
